import { createRequire } from 'node:module';
const _require = createRequire(import.meta.url);
const _m = _require("tree-sitter-wasm");
const _default = _m && _m.__esModule && 'default' in _m ? _m.default : _m;
export default _default;
export const getAvailableQueries = _m["getAvailableQueries"];
export const getQueryPath = _m["getQueryPath"];
export const getWasmPath = _m["getWasmPath"];